import { render, staticRenderFns } from "./Urfo_school_band.vue?vue&type=template&id=49378fae&scoped=true"
import script from "./Urfo_school_band.vue?vue&type=script&lang=js"
export * from "./Urfo_school_band.vue?vue&type=script&lang=js"
import style0 from "./Urfo_school_band.vue?vue&type=style&index=0&id=49378fae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49378fae",
  null
  
)

export default component.exports